(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initMobileMenu();
    initFaqDetails();
    initProductOptionToggle();
    initHeroVideoLazy();
  });

  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-menu-drawer]');
    var closeBtn = drawer && drawer.querySelector('[data-menu-close]');
    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) close();
      else open();
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function initFaqDetails() {
    var items = document.querySelectorAll('details.faq-item');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) d.setAttribute('open', '');
        else d.removeAttribute('open');
      });
    });
  }

  function initProductOptionToggle() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    form.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;

      var variantId = input.getAttribute('data-variant-id');
      var variantInput = form.querySelector('input[name="id"]');
      if (variantInput && variantId) {
        variantInput.value = variantId;
      }
    });
  }

  function initHeroVideoLazy() {
    var videos = document.querySelectorAll('video[data-autoplay]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(playVideo);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          playVideo(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    videos.forEach(function (v) { io.observe(v); });
  }

  function playVideo(video) {
    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.catch(function () {
        video.setAttribute('controls', '');
      });
    }
  }
})();